export const GAUGE_CIRCUMFERENCE = 240
export const GAUGE_ROTATION = -GAUGE_CIRCUMFERENCE / 2
